import $ from 'jquery';

export default class Artist {
    constructor(e) {
        this.$e = $(e);
        if (this.$e.length) this.init();
    }

    init() {
        this.$img = this.$e.find('.artist__image');
        this.$imgs = this.$e.find('.artist__img img');
        $(window).on('resize', () => {
            this.calc();
        });
        $(window).trigger('resize');
        this.loadImgs();
    }
    calc() {
        let h = 0;
        this.$img.find('img').each((i, e) => {
            const $e = $(e);
            $e.on('load', () => {
                if (h < $e.height()) {
                    h = $e.height();
                    h = h - this.$img.height();
                    const px = h + 'px';
                    // this.$img.css('padding-top', px);
                    this.$img.parent().css('padding-top', px).css('margin-top', '-' + px);
                    $('.artist__left').css('max-height', $(window).height() - $('#mainheader').height() - +$('.artist').css('padding-top').replace('px', '') + h);
                    $('.artist__right').css('max-height', $(window).height() - $('#mainheader').height() - +$('.artist').css('padding-top').replace('px', '') + +$('.artist__right').css('padding-top').replace('px', ''));
                }
            });
            if ($e[0].complete) {
                $e.trigger('load');
            }
        });
    }
    loadImgs() {
        let max = Math.min(9, this.$imgs.length);
        let loaded = 0;
        this.$imgs.each((i, e) => {
            if (i < max) {
                const $e = $(e);
                if (e.complete) {
                    loaded++;
                    if (loaded === max) this.loadMoreImgs();
                } else {
                    $e.on('load', () => {
                        loaded++;
                        if (loaded === max) this.loadMoreImgs();
                    });
                }
            }
        });
    }
    loadMoreImgs() {
        this.$imgs.each((i, e) => {
            const $e = $(e);
            if ($e.attr('data-lazy')) {
                $e.attr('src', $e.attr('data-lazy'));
                $e.parents('.artist__img').show();
            }
        });
    }
}